<template>
  <CCard>
    <CCardHeader>
      <CRow>
        <CCol sm="5">
          <h4 id="traffic" class="card-title mb-0">Data Filters</h4>
          <div class="small text-muted" v-if="totalRecords > 0">
            {{ totalRecords }} records found
          </div>
          <div class="small text-muted" v-if="totalRecords === 0">
            No records found
          </div>
        </CCol>
        <CCol sm="7" class="d-none d-md-block">
          <CButton
            color="primary"
            class="float-right"
            @click="showFilter = !showFilter"
          >
            <CIcon name="cil-chevron-bottom" v-if="!showFilter" />

            <CIcon name="cil-chevron-top" v-else />
          </CButton>
        </CCol>
      </CRow>
    </CCardHeader>
    <CCollapse :show="showFilter">
      <CCardBody>
        <CRow class="mb-3">
          <CCol sm="4">
            <CForm>
              <label class="typo__label">Class</label>
              <multiselect
                v-model="selected.class"
                :options="options.class"
                :searchable="true"
                :close-on-select="true"
                :show-labels="true"
                :multiple="false"
                @input="updateFilters('family')"
                placeholder="Select an option"
              >
              </multiselect>
              <!-- <CSelect
                                label="Class"
                                placeholder="Select a one"
                                :options="options.class"
                                :value.sync="selected.class"
                                @change="updateFilters('family')"
                            />       -->
            </CForm>
          </CCol>
          <CCol sm="4">
            <CForm>
              <label class="typo__label">Family Name</label>
              <multiselect
                v-model="selected.family"
                :options="options.family"
                :searchable="true"
                :close-on-select="true"
                :show-labels="true"
                :multiple="false"
                @input="updateFilters('group')"
                placeholder="Select an option"
              >
              </multiselect>
            </CForm>
          </CCol>
          <CCol sm="4">
            <CForm>
              <label class="typo__label">Group Name</label>
              <multiselect
                v-model="selected.group"
                :options="options.group"
                :searchable="true"
                :close-on-select="true"
                :show-labels="true"
                :multiple="false"
                @input="updateFilters('identity')"
                placeholder="Select an option"
              >
              </multiselect>
            </CForm>
          </CCol>
        </CRow>
        <CRow class="mb-3">
          <CCol sm="6">
            <CForm>
              <label class="typo__label">Identity Name</label>
              <multiselect
                v-model="selected.identity"
                :options="options.identity"
                :searchable="true"
                :close-on-select="true"
                :show-labels="true"
                :multiple="false"
                @input="updateIdentityNames('identity')"
                placeholder="Select an option"
              >
              </multiselect>
            </CForm>
          </CCol>
          <CCol sm="6">
            <CForm>
              <label class="typo__label">Scientific Name</label>
              <multiselect
                v-model="selected.scientific"
                :options="options.scientific"
                :searchable="true"
                :close-on-select="true"
                :show-labels="true"
                :multiple="false"
                @input="updateIdentityNames('scientific')"
                placeholder="Select an option"
              >
              </multiselect>
            </CForm>
          </CCol>
        </CRow>
        <CRow v-if="monthly == true" class="mb-3">
          <CCol sm="12">
            <CForm>
              <label>Year Selection</label>
              <multiselect
                v-model="selected.years"
                :options="options.years"
                :multiple="true"
                :close-on-select="false"
              >
              </multiselect>
            </CForm>
          </CCol>
        </CRow>
        <CRow v-else-if="yearly == true" class="mb-3">
          <CCol sm="6">
            <CForm>
              <label class="typo__label">Start Year</label>
              <multiselect
                v-model="selected.startYear"
                :options="options.startYears"
                :searchable="true"
                :close-on-select="true"
                :show-labels="true"
                :multiple="false"
                @input="updateYearlySelection(1)"
                placeholder="Select an option"
              >
              </multiselect>
            </CForm>
          </CCol>
          <CCol sm="6">
            <CForm>
              <label class="typo__label">End Year</label>
              <multiselect
                v-model="selected.endYear"
                :options="options.endYears"
                :searchable="true"
                :close-on-select="true"
                :show-labels="true"
                :multiple="false"
                @input="updateYearlySelection(2)"
                placeholder="Select an option"
              >
              </multiselect>
            </CForm>
          </CCol>
        </CRow>
        <CRow v-else-if="existing == true" class="mb-3">
          <CCol sm="4">
            <CCallout color="danger">
              <b>Select One</b>
              <CInputRadioGroup
                name="sourceTypeRadio"
                :options="timeTypeRadio"
                :value.sync="selected.sourceType"
                :checked="selected.sourceType"
                @update:checked="updateSourceType"
              />
            </CCallout>
          </CCol>
          <CCol sm="4">
            <CInput
              label="Select Start Date"
              type="date"
              v-model="selected.startDate"
            />
          </CCol>
          <CCol sm="4">
            <CInput
              label="Select End Date"
              type="date"
              v-model="selected.endDate"
            />
          </CCol>
        </CRow>
        <CRow v-else class="mb-3">
          <CCol sm="4">
            <CCallout color="danger">
              <b>Select One</b>
              <CInputRadioGroup
                name="sourceTypeRadio"
                :options="timeTypeRadio"
                :value.sync="selected.sourceType"
                :checked="selected.sourceType"
                @update:checked="updateSourceType"
              />
            </CCallout>
          </CCol>
          <CCol sm="4">
            <CInput
              label="Select Start Date"
              type="date"
              v-model="selected.startDate"
            />
          </CCol>
          <CCol sm="4">
            <CInput
              label="Select End Date"
              type="date"
              v-model="selected.endDate"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="4">
            <CForm>
              <label class="typo__label">Facilities</label>
              <multiselect
                v-model="selected.facility"
                :options="options.facilities"
                :searchable="true"
                :close-on-select="true"
                :show-labels="true"
                :multiple="false"
                placeholder="Select an option"
              >
              </multiselect>
            </CForm>
          </CCol>
          <CCol sm="4" v-if="selected.class == 'mammals'">
            <label>Stages</label>
            <multiselect
              v-model="selected.stage"
              :options="options.mammals"
              :multiple="true"
              :close-on-select="false"
            >
            </multiselect>
          </CCol>
          <CCol sm="4" v-if="selected.class == 'aves'">
            <label>Stages</label>
            <multiselect
              v-model="selected.stage"
              :options="options.aves"
              :multiple="true"
              :close-on-select="false"
            >
            </multiselect>
          </CCol>
          <CCol sm="4" v-else-if="selected.class == 'reptiles'">
            <label>Stages</label>
            <multiselect
              v-model="selected.stage"
              :options="options.reptiles"
              :multiple="true"
              :close-on-select="false"
            >
            </multiselect>
          </CCol>
          <CCol sm="4">
            <label>Zone Wise</label>
            <multiselect
              v-model="selected.zone"
              :options="options.zones"
              :multiple="true"
              :close-on-select="false"
            >
            </multiselect>
            <!-- <CCol sm="3">
                            <CSelect
                                label="Zone Wise"
                                :options="options.zones"
                                placeholder="Select a zone"
                                :value.sync="selected.zone"
                            />
                        </CCol> -->
          </CCol>
          <CCol sm="4">
            <label>Rescued By</label>
            <multiselect
              v-model="selected.rescuedBy"
              :options="options.rescuedby"
              :multiple="true"
              :close-on-select="false"
            >
            </multiselect>
            <!-- <CCol sm="3">
                            <CSelect
                                label="Zone Wise"
                                :options="options.zones"
                                placeholder="Select a zone"
                                :value.sync="selected.zone"
                            />
                        </CCol> -->
          </CCol>
        </CRow>
        <CRow class="mt-3">
          <CCol sm="6">
            <label>Cause of Displacement</label>
            <multiselect
              v-model="selected.causeOfDisp"
              :options="options.causeOfDisp"
              :multiple="true"
              :close-on-select="false"
            >
            </multiselect>
          </CCol>
          <CCol sm="6">
            <CForm>
              <label class="typo__label">Final Outcome</label>
              <multiselect
                v-model="selected.outcome"
                :options="options.outcomes"
                :searchable="true"
                :close-on-select="true"
                :show-labels="true"
                :multiple="false"
                placeholder="Select an option"
              >
              </multiselect>
            </CForm>
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="12" class="text-center mt-2">
            <div style="min-height: 25px">
              <pulse-loader
                :loading="filterLoading"
                color="green"
              ></pulse-loader>
            </div>
          </CCol>
        </CRow>
        <!-- <CRow>
                    <CCol sm="6">                     
                        <CForm>
                            <label class="typo__label">Place of Rescue</label>
                            <multiselect 
                                v-model="selected.placeOfRescue" 
                                :options="options.placeOfRescue" 
                                :searchable="true" 
                                :close-on-select="false" 
                                :show-labels="true" 
                                :multiple="true"
                                open-direction="bottom"
                                :loading="placeLoading"
                                :internal-search="false" 
                                :options-limit="300" 
                                :limit="3" 
                                :limit-text="limitText" 
                                :max-height="900" 
                                :show-no-results="true" 
                                :hide-selected="true" 
                                @search-change="asyncFind"
                                placeholder="Type to search..">

                                <template slot="clear" slot-scope="props">
                                    <div class="multiselect__clear" v-if="selected.placeOfRescue.length > 0" @mousedown.prevent.stop="clearAll(props.search)"></div>
                                </template>

                                <span slot="noResult">Oops! No places found. Consider changing the search query.</span>
                            </multiselect> 
                        </CForm>     
                        
                        
                        <CForm>
                            <label class="typo__label">Place of Rescue</label>
                            <CInput 
                                placeholder="Start typing place of rescue.."
                                v-model="selected.placeOfRescueText"
                            >
                                <template #prepend>
                                    <CButton color="primary" @click="apply()">
                                    <CIcon name="cil-magnifying-glass"/> Search
                                    </CButton>
                                </template>
                            </CInput>
                        </CForm>
                    </CCol>     
                    <CCol sm="6">                                       
                        <CForm>
                            <label class="typo__label">Place of Release</label>
                            <CInput 
                                placeholder="Start typing place of release.."
                                v-model="selected.placeOfReleaseText"
                            >
                                <template #prepend>
                                    <CButton color="primary" @click="apply()">
                                    <CIcon name="cil-magnifying-glass"/> Search
                                    </CButton>
                                </template>
                            </CInput>
                        </CForm>
                    </CCol>    
                </CRow> -->
        <CRow>
          <CCol sm="6">
            <CForm>
              <label class="typo__label">Search by case number</label>
              <CInput
                placeholder="Start typing case number.."
                v-model="selected.caseno"
              >
                <!-- <template #prepend>
                                    <CButton color="primary" @click="apply()">
                                    <CIcon name="cil-magnifying-glass"/> Search
                                    </CButton>
                                </template> -->
              </CInput>
            </CForm>
          </CCol>
          <CCol sm="6">
            <!-- <CForm>
                            <label class="typo__label">Search by place of rescue</label>
                            <CInput 
                                placeholder="Start typing place of rescue.."
                                v-model="selected.placeOfRescueText"
                            >
                                <template #prepend>
                                    <CButton color="primary" @click="apply()">
                                    <CIcon name="cil-magnifying-glass"/> Search
                                    </CButton>
                                </template>
                            </CInput>
                        </CForm> -->
            <CInput
              label="Search by place of rescue"
              type="text"
              placeholder="Start typing place of rescue.."
              v-model="selected.placeOfRescueText"
              @input="onInputrescue"
            />
            <ul v-if="suggestionsrescue.length && selected.placeOfRescueText">
              <li
                v-for="suggestions in suggestionsrescue"
                :key="suggestions"
                @click="selectSuggestionrescue(suggestions)"
                class="suggestion-item"
              >
                {{ suggestions }}
              </li>
            </ul>
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="12">
            <!-- <CForm>
                            <label class="typo__label">Search by place of outcome</label>
                            <CInput 
                                placeholder="Start typing place of outcome.."
                                v-model="selected.placeofOctm"
                            >
                                <template #prepend>
                                    <CButton color="primary" @click="apply()">
                                    <CIcon name="cil-magnifying-glass"/> Search
                                    </CButton>
                                </template>
                            </CInput>
                        </CForm> -->
            <CInput
              label="Search by place of outcome"
              type="text"
              placeholder="Start typing place of outcome.."
              v-model="selected.placeofOctm"
              @input="onInput"
            />
            <ul v-if="suggestions.length && selected.placeofOctm">
              <li
                v-for="suggestion in suggestions"
                :key="suggestion"
                @click="selectSuggestion(suggestion)"
                class="suggestion-item"
              >
                {{ suggestion }}
              </li>
            </ul>
          </CCol>
        </CRow>
      </CCardBody>
    </CCollapse>
    <CCardFooter class="text-center">
      <CRow>
        <CCol sm="6">
          <CButton type="submit" color="danger" @click="reset()"
            ><CIcon name="cil-reload" /> Reset Filters</CButton
          >
        </CCol>
        <CCol sm="6">
          <CButton type="submit" color="primary" @click="apply()"
            ><CIcon name="cil-check-circle" /> Apply Filters</CButton
          >
        </CCol>
      </CRow>
    </CCardFooter>
  </CCard>
</template>
<script>
import Multiselect from "vue-multiselect";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import axios from "axios";
import store from "../../store";

export default {
  name: "DataFilter",
  components: {
    Multiselect,
    PulseLoader,
  },
  props: {
    tableLength: { required: true, type: Number, default: 0 },
    monthly: { required: false, type: Boolean, default: false },
    yearly: { required: false, type: Boolean, default: false },
    existing: { required: false, type: Boolean, default: false },
  },
  data() {
    return {
      suggestions: [], // Add this line
      suggestionsrescue: [],
      baseURL: store.state.baseURL,
      showFilter: false,
      filterLoading: true,
      loading: true,
      options: {
        outcomes: [],
        zones: [],
        rescuedby: ["By WTI", "By FD", "By WTI & FD", "Others"],
        class: [],
        group: [],
        identity: [],
        scientific: [],
        family: [],
        stages: [],
        mammals: ["Adult", "Subadult", "Juvenile", "Neonate"],
        reptiles: ["Adult", "Subadult", "Juvenile", "Hatchling"],
        aves: ["Mature", "Immature", "Fledgling", "Hatchling"],
        facilities: [],
        causeOfDisp: [],
        placeOfRescue: [],
        placeOfRescueText: "",
        placeOfoutcome: "",
        placeOfReleaseText: "",
        months: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
        years: [],
      },
      selected: {
        sourceIntervalType: null,
        sourceType: 'admission',
        date: null,
        startDate: null,
        endDate: null,
        outcome: null,
        zone: [],
        class: null,
        family: null,
        group: null,
        identity: null,
        caseno: null,
        scientific: null,
        stage: [],
        facility: null,
        placeOfReleaseText: "",
        placeOfRescueText: "",
        placeofOctm: "",
        causeOfDisp: [],
        month: null,
        year: null,
        years: [],
        startYear: null,
        endYear: null,
      },
      filter: {
        startDate: null,
        endDate: null,
        class: null,
        family: null,
        group: null,
        identity: null,
        scientific: null,
        zone: null,
        outcome: null,
        timeType: null,
        date: null,
        timeIntervalType: null,
        caseno: null,
        stage: null,
        facility: null,
        placeOfReleaseText: "",
        placeOfRescueText: "",
        placeOfoutcome: "",
        causeOfDisp: null,
        startYear: null,
        endYear: null,
        years: [],
      },
      timeIntervalTypeRadio: [
        { value: "month", label: "Monthly Data" },
        { value: "year", label: "Yearly Data" },
        { value: "range", label: "Date Range" },
      ],

      timeTypeRadio: [
        { value: "admission", label: "Date of Admission" },
        { value: "outcome", label: "Date of Outcome" },
      ],
      searchText: "",
      placeLoading: false,
    };
  },
  created() {
    this.loading = true;
    this.yearOptionsUpdate();
    this.selected = {
      sourceIntervalType: store.state.filters.sourceIntervalType,
      sourceType: store.state.filters.sourceType,
      date: store.state.filters.date,
      startDate: store.state.filters.startDate,
      endDate: store.state.filters.endDate,
      outcome: store.state.filters.outcome,
      zone: store.state.filters.zone,
      class: store.state.filters.class,
      family: store.state.filters.family,
      group: store.state.filters.group,
      identity: store.state.filters.identity,
      caseno: store.state.filters.caseno,
      scientific: store.state.filters.scientific,
      stage: store.state.filters.stage,
      facility: store.state.filters.facility,
      placeOfReleaseText: store.state.filters.placeOfReleaseText,
      placeOfRescueText: store.state.filters.placeOfRescueText,
      placeOfoutcome: store.state.filters.placeOfRescueText,
      causeOfDisp: store.state.filters.causeOfDisp,
      month: store.state.filters.month,
      year: store.state.filters.year,
      years: store.state.filters.years,
      startYear: null,
      endYear: null,
    };
    // console.log("haii get", store.state.filters)

    if (this.monthly) {
      let currentYear = new Date().getFullYear();
      this.selected.sourceIntervalType = "year";
      this.selected.sourceType = store.state.filters.sourceType;
      this.selected.date = new Date("01-05-" + currentYear);

      this.yearOptionsUpdate();
      this.updateYearSelection();
    } else if (this.yearly) {
      // this.selected.sourceIntervalType = 'year';
      this.selected.timeIntervalType = "admission";
      this.dualYearOptionsUpdate();
    } else {
      this.selected.sourceIntervalType = "range";
      this.selected.sourceType = store.state.filters.sourceType;
      this.selected.date = null;
    }

    this.filter = {
      startDate: this.selected.startDate,
      endDate: this.selected.endDate,
      class: this.selected.class,
      family: this.selected.family,
      group: this.selected.group,
      identity: this.selected.identity,
      scientific: this.selected.scientific,
      zone: this.selected.zone,
      outcome: this.selected.outcome,
      timeType: this.selected.sourceType,
      date: this.selected.date,
      timeIntervalType: this.selected.sourceIntervalType,
      caseno: this.selected.caseno,
      stage: this.selected.stage,
      facility: this.selected.facility,
      placeOfReleaseText: this.selected.placeOfReleaseText,
      placeOfRescueText: this.selected.placeOfRescueText,
      placeOfoutcome: this.selected.placeOfoutcome,
      causeOfDisp: this.selected.causeOfDisp,
      startYear: this.selected.startYear,
      endYear: this.selected.endYear,
      years: this.selected.year,
    };
    this.getFilters();
    this.getRecords(true);
  },
  computed: {
    totalRecords() {
      return this.tableLength;
    },
  },
  methods: {
    limitText(count) {
      return `and ${count} other places`;
    },
    asyncFind(query) {
      if (query.length > 3) {
        this.placeLoading = true;

        axios({
          url: this.baseURL + "records/filters/place?p=" + query,
          headers: {
            authorization: store.state.token,
          },
          method: "GET",
        })
          .then((res) => {
            if (res.data.status) {
              this.options.placeOfRescue = res.data.data;
            } else {
              this.options.placeOfRescue = [];
              this.$notify({
                group: "notification",
                type: "error",
                title: "Important message",
                text: res.data.message,
              });
            }
            this.placeLoading = false;
          })
          .catch((err) => {
            this.$notify({
              group: "notification",
              type: "error",
              title: "Important message",
              text: "Error in loading data. Something went wrong!",
            });
            console.log(err);
            this.placeLoading = false;
            return [];
          });
      }
    },
    onInputrescue() {
      if (this.selected.placeOfRescueText.length >= 4) {
        this.fetchSuggestionsrescue(this.selected.placeOfRescueText);
      } else {
        this.suggestionsrescue = [];
      }
    },
    onInput() {
      if (this.selected.placeofOctm.length >= 4) {
        this.fetchSuggestions(this.selected.placeofOctm);
      } else {
        this.suggestions = [];
      }
    },
    selectSuggestion(suggestion) {
      this.selected.placeofOctm = suggestion;
      this.suggestions = [];
    },
    fetchSuggestions(keyword) {
      this.loading = true;
      axios({
        url: this.baseURL + "analytics/placeofoutcome-wise",
        headers: {
          authorization: store.state.token,
        },
        data: {
          placeOfOutcome: keyword,
        },
        method: "POST",
      })
        .then((res) => {
          if (res.data.status) {
            this.suggestions = res.data.data;
          } else {
            this.$notify({
              group: "notification",
              type: "error",
              title: "Important message",
              text: res.data.message,
            });
            this.suggestions = [];
          }
          this.loading = false;
        })
        .catch((err) => {
          this.$notify({
            group: "notification",
            type: "error",
            title: "Important message",
            text: "Error in loading data. Something went wrong!",
          });
          console.log(err);
          this.loading = false;
          this.suggestions = [];
        });
    },
    fetchSuggestionsrescue(keyword) {
      this.loading = true;
      axios({
        url: this.baseURL + "analytics/placeofrescue-wise",
        headers: {
          authorization: store.state.token,
        },
        data: {
          placeOfRescue: keyword,
        },
        method: "POST",
      })
        .then((res) => {
          if (res.data.status) {
            this.suggestionsrescue = res.data.data;
          } else {
            this.$notify({
              group: "notification",
              type: "error",
              title: "Important message",
              text: res.data.message,
            });
            this.suggestionsrescue = [];
          }
          this.loading = false;
        })
        .catch((err) => {
          this.$notify({
            group: "notification",
            type: "error",
            title: "Important message",
            text: "Error in loading data. Something went wrong!",
          });
          console.log(err);
          this.loading = false;
          this.suggestionsrescue = [];
        });
    },
    selectSuggestionrescue(suggestions) {
      this.selected.placeOfRescueText = suggestions;
      this.suggestionsrescue = [];
    },
    clearAll() {
      this.selected.placeOfRescue = [];
    },
    yearOptionsUpdate() {
      this.options.years = [];
      let currentYear = new Date().getFullYear();
      let currentMonth = new Date().getMonth();
      for (var i = 1995; i <= currentYear; i++) {
        this.options.years.push(i);
      }
      this.selected.year = currentYear;
      this.selected.month = this.options.months[currentMonth];
    },
    dualYearOptionsUpdate() {
      this.options.startYears = [];
      this.options.endYears = [];
      let currentYear = new Date().getFullYear();
      for (var i = 1995; i < currentYear; i++) {
        this.options.startYears.push(i);
      }
      for (var i = 1995; i <= currentYear; i++) {
        this.options.endYears.push(i);
      }
      this.selected.startYear = currentYear - 9;
      this.selected.endYear = currentYear;
      this.filter.startYear = currentYear - 9;
      this.filter.endYear = currentYear;
    },
    updateTimeSelection() {
      let month = this.options.months.indexOf(this.selected.month) + 1;
      this.selected.date = new Date(month + "-03-" + this.selected.year);
    },
    updateSourceIntervalType(value, event) {
      this.selected.sourceIntervalType = value;
    },
    updateSourceType(value, event) {
      this.selected.sourceType = value;
    },
    updateYearSelection() {
      this.selected.date = new Date("01-05-" + this.selected.year);
    },
    updateYearlySelection(mode) {
      let yearDifference = this.selected.endYear - this.selected.startYear;
      if (mode == 1) {
        //Start year selected
        if (yearDifference > 9) {
          this.selected.endYear = this.selected.startYear + 9;
        } else if (yearDifference < 0) {
          this.selected.endYear = this.selected.startYear + 1;
        }
      } else {
        //End year Selected
        if (yearDifference > 9) {
          this.selected.startYear = this.selected.endYear - 9;
        } else if (yearDifference < 0) {
          this.selected.startYear = this.selected.endYear - 1;
        }
      }
    },
    apply() {
      var errors = "";

      if (errors != "") {
        this.$notify({
          group: "notification",
          type: "error",
          title: "Important message",
          text: errors,
        });
      } else {
        this.filter = {
          startDate: this.selected.startDate,
          endDate: this.selected.endDate,
          class: this.selected.class,
          family: this.selected.family,
          group: this.selected.group,
          identity: this.selected.identity,
          scientific: this.selected.scientific,
          zone: this.selected.zone,
          rescuedBy: this.selected.rescuedBy,
          outcome: this.selected.outcome,
          timeType: this.selected.sourceType,
          date: this.selected.date,
          timeIntervalType: this.selected.sourceIntervalType,
          caseno: this.selected.caseno,
          stage: this.selected.stage,
          facility: this.selected.facility,
          placeOfReleaseText: this.selected.placeOfReleaseText,
          placeOfRescueText: this.selected.placeOfRescueText,
          placeofOctm: this.selected.placeofOctm,
          causeOfDisp: this.selected.causeOfDisp,
          years: this.selected.years,
        };

        if (this.yearly == true) {
          this.filter.startYear = this.selected.startYear;
          this.filter.endYear = this.selected.endYear;
        }
        store.commit("updateFilter", this.filter);
        // console.log("haii filter",this.filter)
        this.getRecords(true);
      }
    },

    reset() {
      (this.selected = {
        sourceIntervalType: "range",
        sourceType: "admission",
        date: null,
        startDate: null,
        endDate: null,
        outcome: null,
        zone: [],
        rescuedby: [],
        class: null,
        group: null,
        identity: null,
        caseno: null,
        scientific: null,
        family: null,
        stage: null,
        facility: null,
        placeOfReleaseText: "",
        placeOfRescueText: "",
        placeOfoutcome: "",
        causeOfDisp: [],
        years: [],
      }),
        (this.filter = {
          startDate: null,
          endDate: null,
          class: null,
          group: null,
          identity: null,
          zone: null,
          outcome: null,
          timeType: this.selected.sourceType,
          date: null,
          timeIntervalType: this.selected.sourceIntervalType,
          caseno: null,
          scientific: null,
          family: null,
          stage: null,
          facility: null,
          placeOfReleaseText: "",
          placeOfRescueText: "",
          placeOfoutcome: "",
          causeOfDisp: null,
          years: [],
        });
      store.commit("updateFilter", this.filter);
      this.options.group = [];
      this.options.identity = [];
      this.options.family = [];
      this.options.scientific = [];
      this.options.placeOfRescue = [];
      this.items = [];
      this.tableLength = 0;
      (this.searchText = ""), this.getRecords(true);
    },
    getRecords(reset) {
      this.$emit("input", this.filter);
    },
    getFilters() {
      this.filterLoading = true;
      axios({
        url: this.baseURL + "records/filters",
        headers: {
          authorization: store.state.token,
        },
        data: {
          class: this.selected.class != null ? this.selected.class : null,
        },
        method: "POST",
      })
        .then((res) => {
          if (res.data.status) {
            this.options.outcomes = res.data.data.outcomes;
            this.options.facilities = res.data.data.facilities;
            // this.options.stages = res.data.data.stages;
            this.options.class = res.data.data.classes;
            this.options.zones = res.data.data.zones;
            this.options.causeOfDisp = res.data.data.displacement;
            this.options.group = res.data.data.group;
            this.options.identity = res.data.data.identity;
            this.options.family = res.data.data.family;
            this.options.scientific = res.data.data.scientific;
          } else {
            this.items = [];
            this.tableLength = 0;
            this.$notify({
              group: "notification",
              type: "error",
              title: "Important message",
              text: res.data.message,
            });
          }
          this.filterLoading = false;
        })
        .catch((err) => {
          this.$notify({
            group: "notification",
            type: "error",
            title: "Important message",
            text: "Error in loading data. Something went wrong!",
          });
          console.log(err);
          this.filterLoading = false;
          return [];
        });
    },
    updateIdentityNames(type) {
      console.log(type);
      if (type == "identity") {
        this.selected.scientific = null;
      } else {
        this.selected.identity = null;
      }
    },
    updateFilters(type, id) {
      this.filterLoading = true;

      if (type == "family") {
        this.selected.family = null;
        this.selected.group = null;
      } else if (type == "group") {
        this.selected.group = null;
      }

      this.selected.scientific = null;
      this.selected.identity = null;

      axios({
        url: this.baseURL + "records/filters/animal",
        headers: {
          authorization: store.state.token,
        },
        data: {
          class: this.selected.class,
          family: this.selected.family != null ? this.selected.family : null,
          group: this.selected.group != null ? this.selected.group : null,
          type: type,
        },
        method: "POST",
      })
        .then((res) => {
          if (res.data.status) {
            this.options.class = res.data.data.class;
            this.options.group = res.data.data.group;
            this.options.identity = res.data.data.identity;
            this.options.family = res.data.data.family;
            this.options.scientific = res.data.data.scientific;
          } else {
            this.$notify({
              group: "notification",
              type: "error",
              title: "Important message",
              text: res.data.message,
            });
          }
          this.filterLoading = false;
        })
        .catch((err) => {
          this.$notify({
            group: "notification",
            type: "error",
            title: "Important message",
            text: "Error in loading data. Something went wrong!",
          });
          console.log(err);
          this.filterLoading = false;
          return [];
        });
    },
  },
};
</script>
<style scoped>
.suggestion-item {
  cursor: pointer;
}
</style>